import CertificateValidityPeriod from './CertificateValidityPeriod'

export default CertificateValidityPeriod
